var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1795 7.62337L20.557 6.54328C20.0305 5.62936 18.8635 5.31408 17.9483 5.83847V5.83847C17.5127 6.0951 16.9929 6.16791 16.5035 6.04084C16.0141 5.91378 15.5954 5.59727 15.3396 5.16113C15.1751 4.8839 15.0867 4.56815 15.0834 4.2458V4.2458C15.0982 3.72898 14.9032 3.22816 14.5428 2.85743C14.1824 2.48669 13.6873 2.27762 13.1703 2.27783H11.9163C11.4098 2.27783 10.9241 2.47967 10.5668 2.8387C10.2095 3.19773 10.01 3.68435 10.0124 4.19088V4.19088C9.9974 5.23668 9.14528 6.07657 8.09937 6.07646C7.77701 6.07311 7.46126 5.9847 7.18404 5.82017V5.82017C6.26886 5.29577 5.10192 5.61105 4.57534 6.52497L3.90715 7.62337C3.38121 8.53615 3.6922 9.70236 4.6028 10.2321V10.2321C5.19471 10.5738 5.55933 11.2053 5.55933 11.8888C5.55933 12.5723 5.19471 13.2038 4.6028 13.5456V13.5456C3.69336 14.0717 3.38203 15.2351 3.90715 16.1451V16.1451L4.53873 17.2344C4.78545 17.6795 5.19941 18.0081 5.689 18.1472C6.17859 18.2863 6.70344 18.2247 7.14742 17.9758V17.9758C7.58388 17.7211 8.10399 17.6513 8.59214 17.782C9.08029 17.9126 9.49604 18.2328 9.74697 18.6714C9.9115 18.9486 9.99991 19.2644 10.0033 19.5868V19.5868C10.0033 20.6433 10.8598 21.4998 11.9163 21.4998H13.1703C14.2233 21.4998 15.0783 20.6489 15.0834 19.5959V19.5959C15.0809 19.0878 15.2817 18.5998 15.641 18.2405C16.0003 17.8812 16.4883 17.6804 16.9964 17.6829C17.318 17.6915 17.6324 17.7795 17.9117 17.9392V17.9392C18.8245 18.4651 19.9907 18.1541 20.5204 17.2435V17.2435L21.1795 16.1451C21.4346 15.7073 21.5046 15.1858 21.374 14.6961C21.2434 14.2065 20.9231 13.7891 20.4838 13.5364V13.5364C20.0446 13.2837 19.7242 12.8663 19.5936 12.3767C19.463 11.8871 19.5331 11.3656 19.7882 10.9277C19.954 10.6381 20.1942 10.398 20.4838 10.2321V10.2321C21.3889 9.70265 21.6992 8.54325 21.1795 7.63252V7.63252V7.62337Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5479,
    cy: 11.8886,
    r: 2.63616,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/setting-icon.bde2676e533c990c9eddc37ed78c09d1.svg";
export { ForwardRef as ReactComponent };